import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import LaneBoard from "@/components/site/LaneBoard";
import Manifesto from "@/components/site/Manifesto";
import Stats from "@/components/site/Stats";
import Gallery from "@/components/site/Gallery";
import MapReviews from "@/components/site/MapReviews";
import Careers from "@/components/site/Careers";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    const reduce =
      window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      window.location.search.includes("nomotion");
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.3, smoothWheel: true, lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main data-testid="landing-page" className="relative overflow-x-clip">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <LaneBoard />
      <Manifesto />
      <Stats />
      <Gallery />
      <MapReviews />
      <Careers />
      <Contact />
      <Footer />
    </main>
  );
}
